import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './OrderProductsModal.module.scss';

interface OrderItem {
  productName: string;
  sku: string;
  quantity: number;
  price: number;
}

interface OrderProductsModalProps {
  show: boolean;
  onHide: () => void;
  orderNumber: string;
  items: OrderItem[];
}

const OrderProductsModal: React.FC<OrderProductsModalProps> = ({ show, onHide, orderNumber, items }) => {
  const getTotalAmount = () => {
    return items.reduce((sum, item) => sum + (item.price * item.quantity), 0).toFixed(2);
  };

  return (
    <Modal show={show} onHide={onHide} centered className={styles.orderProductsModal}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Order {orderNumber} - Products</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <table className={styles.productsTable}>
          <thead>
            <tr>
              <th>Product</th>
              <th>SKU</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>{item.productName}</td>
                <td className={styles.sku}>{item.sku}</td>
                <td className={styles.quantity}>{item.quantity}</td>
                <td className={styles.price}>${item.price.toFixed(2)}</td>
                <td className={styles.lineTotal}>${(item.price * item.quantity).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={4} className={styles.totalLabel}>Total Amount:</td>
              <td className={styles.totalAmount}>${getTotalAmount()}</td>
            </tr>
          </tfoot>
        </table>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <Button variant="secondary" onClick={onHide} className={styles.closeButton}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderProductsModal;
